module.exports = __webpack_public_path__ + "img/the-knot-23.e8a950c3.png";